export function OutlineFaceSmileIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 8C14.5 4.40625 11.5938 1.5 8 1.5C4.40625 1.5 1.5 4.40625 1.5 8C1.5 11.5938 4.40625 14.5 8 14.5C11.5938 14.5 14.5 11.5938 14.5 8ZM0 8C0 3.59375 3.59375 0 8 0C12.4062 0 16 3.59375 16 8C16 12.4062 12.4062 16 8 16C3.59375 16 0 12.4062 0 8ZM5.53125 9.96875C6 10.4688 6.8125 11 8 11C9.1875 11 10 10.4688 10.4688 9.96875C10.75 9.6875 11.2188 9.6875 11.5312 9.96875C11.8125 10.25 11.8438 10.7188 11.5312 11.0312C10.8438 11.75 9.65625 12.5 8 12.5C6.34375 12.5 5.15625 11.75 4.46875 11.0312C4.1875 10.7188 4.1875 10.25 4.46875 9.96875C4.78125 9.6875 5.25 9.6875 5.53125 9.96875ZM4.5 6.5C4.5 5.9375 4.9375 5.5 5.5 5.5C6.0625 5.5 6.5 5.9375 6.5 6.5C6.5 7.0625 6.0625 7.5 5.5 7.5C4.9375 7.5 4.5 7.0625 4.5 6.5ZM10.5 5.5C11.0625 5.5 11.5 5.9375 11.5 6.5C11.5 7.0625 11.0625 7.5 10.5 7.5C9.9375 7.5 9.5 7.0625 9.5 6.5C9.5 5.9375 9.9375 5.5 10.5 5.5Z"
        fill={stroke}
      />
    </svg>
  );
}
